module.exports = __webpack_public_path__ + "static/media/logo-ko-saratogahospital.092a80bc.svg";